import { render } from "./AddedGood.vue?vue&type=template&id=7577e11b"
import script from "./AddedGood.vue?vue&type=script&lang=js"
export * from "./AddedGood.vue?vue&type=script&lang=js"
script.render = render

export default script